export const SET_SOLICITATION_ID = "SET_SOLICITATION_ID";